import { EmailTemplate } from '../../types';

export enum USLLCIncorporationTaskGroups {
  COMPANY_FORMATION_DETAILS = 'COMPANY_FORMATION_DETAILS',
  INCORPORATION_FILING = 'INCORPORATION_FILING',
  EIN_PROOF = 'PROCURING_EIN_PROOF',
  EIN_LETTER = 'EIN_LETTER',
  BANK_ACCOUNT_CREATION = 'BANK_ACCOUNT_CREATION',
  BOI_FILING = 'BOI_FILING',
}

export enum USLLCIncorporationTasks {
  FILL_CORPORATION_DETAILS = 'FILL_CORPORATION_DETAILS',
  REVIEW_CORPORATION_DETAILS = 'REVIEW_CORPORATION_DETAILS',
  FILE_INCORPORATION = 'FILE_INCORPORATION',
  UPLOAD_INCORPORATION_DOCUMENTS = 'UPLOAD_INCORPORATION_DOCUMENTS',
  FILL_INCORPORATION_DETAILS = 'FILL_INCORPORATION_DETAILS',
  SEND_EMAIL_UPDATE = 'SEND_EMAIL_UPDATE',
  UPLOAD_EIN_PROOF = 'UPLOAD_EIN_PROOF',
  UPLOAD_EIN_LETTER = 'UPLOAD_EIN_LETTER',
  CLIENT_ADD_BANK_ACCOUNT = 'CLIENT_ADD_BANK_ACCOUNT',
  CLIENT_UPLOAD_BANK_WIRE_INSTRUCTIONS = 'CLIENT_UPLOAD_BANK_WIRE_INSTRUCTIONS',
  BOI_FILING_ACKNOWLEDGEMENT = 'BOI_FILING_ACKNOWLEDGEMENT',
}

export const US_LLC_TASK_GROUP_TO_EMAIL_MAP: Record<
  USLLCIncorporationTaskGroups,
  EmailTemplate | null
> = {
  [USLLCIncorporationTaskGroups.COMPANY_FORMATION_DETAILS]: null,
  [USLLCIncorporationTaskGroups.INCORPORATION_FILING]: {
    body: `Hi,

Your initial incorporation documents are ready and you can find them in the documents tab of your dashboard.

Your EIN application is in progress.

Warm Regards

Commenda Team`,
    subject: 'Update on filing status with Commenda',
  },
  [USLLCIncorporationTaskGroups.EIN_PROOF]: {
    body: `Hi,

Your EIN has been issued and the screenshot is available on the Commenda dashboard.

The letter will be uploaded to the dashboard upon arrival.

The next step is to get a bank account. Sharing collaterals on Mercury, Brex, and Truly that you can look at for US banking-

Mercury - https://mercury.com/partner/commenda

Brex - [https://www.brex.com/lp/startups-lw1?partnerId=commenda](https://www.brex.com/lp/startups-lw1?partnerId=commenda%5C)

Truly - https://trulyfinancial.com/?ref=njlhzjk

Warm Regards

Commenda Team`,
    subject: 'Update on EIN status with Commenda',
  },
  [USLLCIncorporationTaskGroups.EIN_LETTER]: {
    body: `Hi,

Your EIN letter has been uploaded to the Commenda dashboard.

The next step is to get a bank account. Sharing collaterals on Mercury, Brex, and Truly that you can look at for US banking-

Mercury - https://mercury.com/partner/commenda

Brex - [https://www.brex.com/lp/startups-lw1?partnerId=commenda](https://www.brex.com/lp/startups-lw1?partnerId=commenda%5C)

Truly - https://trulyfinancial.com/?ref=njlhzjk

Warm Regards

Commenda Team`,
    subject: 'Update on EIN status with Commenda',
  },
  [USLLCIncorporationTaskGroups.BANK_ACCOUNT_CREATION]: null,
  [USLLCIncorporationTaskGroups.BOI_FILING]: null,
};
